import script from "./CalendarEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEvents.vue?vue&type=style&index=0&id=69475068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69475068"]])

export default __exports__